import userRepository from "./UserRepository";
import auth from "./auth";
import kategoriSoalRepository from "./KategoriSoalRepository";
import kategoriTryoutRepository from "./KategoriTryoutRepository";
import paketTryoutRepository from "./PaketTryoutRepository";
import soalRepository from "./SoalRepository";
import mapelRepository from "./MapelRepository";
import paketMapelRepository from "./PaketMapelRepository";
import paketKategoriRepository from "./PaketKategoriRepository";
import materiDokumenRepository from "./MateriDokumenRepository";
import PtnRepository from "./PtnRepository";
import ProdiRepository from "./ProdiRepository";
import ProdiDetailRepository from "./ProdiDetailRepository";
import InvoiceRepository from "./Invoice";
import BayarRepository from "./Bayar";
import ProductsRepository from "./ProductsRepository";
import HasilTryoutRepositories from "./HasilTryoutRepositories";

//Daerah
import ProvinsiRepository from "./ProvinsiRepository";
import KotaRepository from "./KotaRepository";
import KecamatanRepository from "./KecamatanRepository";

// Dashboard
import DashboardRepository from "./DashboardRepository";

// Jenis
import JenisRepository from "./JenisRepository";

// Event
import EventRepository from "./EventRepository";

// Bundle
import BundleRepository from "./BundleRepository";

import VoucherRepository from "./VoucherRepository";
import IrtRepository from "./IrtRepository";
import CopyPaketTryoutRepository from "./CopyPaketTryoutRepository";

const repositories = {
  userRepository,
  auth,
  kategoriSoalRepository,
  soalRepository,
  mapelRepository,
  paketKategoriRepository,
  paketMapelRepository,
  kategoriTryoutRepository,
  paketTryoutRepository,
  materiDokumenRepository,
  PtnRepository,
  ProdiRepository,
  ProdiDetailRepository,
  InvoiceRepository,
  BayarRepository,
  ProductsRepository,
  HasilTryoutRepositories,

  //Daerah
  ProvinsiRepository,
  KotaRepository,
  KecamatanRepository,

  // Dashboard
  DashboardRepository,

  // Jenis
  JenisRepository,

  // Event
  EventRepository,

  // Bundle
  BundleRepository,

  VoucherRepository,
  IrtRepository,
  CopyPaketTryoutRepository,
};
export default {
  get: name => repositories[name],
};
